import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import en from "./en.json";
import es from "./es.json";

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: { en: { translation: en }, es: { translation: es } },
    fallbackLng: "en",
    supportedLngs: ["en", "es"],
    nonExplicitSupportedLngs: true, // es-ES, es-PR, en-US → es / en
    load: "languageOnly",
    detection: {
      order: ["localStorage", "navigator"],
      lookupLocalStorage: "hephy_lang",
      caches: ["localStorage"],
    },
    interpolation: { escapeValue: false },
  });

export function setLang(lng) {
  i18n.changeLanguage(lng);
  try { localStorage.setItem("hephy_lang", lng); } catch { /* noop */ }
}

export function hasManualLang() {
  try { return !!localStorage.getItem("hephy_lang"); } catch { return false; }
}

export default i18n;
